module.exports = __webpack_public_path__ + "static/media/Levi_napkin_blue.d7421571.jpg";